import React from 'react';

export const GenderIcon = () => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M14.6884 4.169L14.1561 2.18213M14.1561 2.18213L12.169 2.71445M14.1561 2.18213L12.701 4.7014M12.701 4.7014C11.3096 3.89811 9.53053 4.37482 8.72724 5.76616C7.92395 7.1575 8.40066 8.9366 9.792 9.73989C11.1833 10.5432 12.9624 10.0665 13.7657 8.67513C14.569 7.28379 14.0923 5.50469 12.701 4.7014ZM3.93263 10.0473C5.50212 10.0473 6.77445 8.77496 6.77445 7.20547C6.77445 5.63598 5.50212 4.36365 3.93263 4.36365C2.36314 4.36365 1.09082 5.63598 1.09082 7.20547C1.09082 8.77496 2.36314 10.0473 3.93263 10.0473ZM3.93263 10.0473L3.93315 13.0909M2.51199 11.9418H5.3538"
            stroke="#1F2F3B"
            strokeWidth="1.09091"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export default GenderIcon;
